import React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from '../../views/PageHeader/PageHeader';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import { NavLink } from 'react-router-dom';

import { useStyles } from './DoctorProfileStyles.js';

const Profile = ({ doctorProfile }) => {

    const classes = useStyles();

    const { slug } = useParams();
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        (async () => {
            const profile = await doctorProfile(slug);
            setProfile(profile);
        })();
    }, [doctorProfile, slug]);

    if (!profile || profile.length === 0) return <Box sx={{ minHeight: '100vh' }} />;
    return (
        <Box sx={{ padding: '30px' }}>
            <Grid container >
                <Grid item xs={12} sm={12} md={4} sx={{ padding: '20px' }}>
                    <img src={profile.image} className={classes.doctorImage} />
                </Grid>
                <Grid item xs={12} sm={12} md={8} sx={{ padding: '20px' }}>
                    <Typography variant="h2" className={classes.doctorName}>
                        {profile.title} {profile.last_name} {profile.first_name}
                    </Typography>
                    <Typography mt={3} className={classes.doctorDescription} >
                        {profile.description}
                    </Typography>
                    <Typography mt={3} className={classes.doctorSubName}>
                        Aree di interesse
                    </Typography>
                    {profile.departmentNames.map((department) => {
                        return (
                            <Typography key={department.slug} className={classes.doctorDepartments}>
                                {department.name}
                            </Typography>
                        );
                    })}
                    <Typography mt={5} mb={3} className={classes.doctorSubName}>
                        Informazioni di contatto
                    </Typography>
                    <Grid container>
                        <Grid item key="doctorEmail" xs={12} mb={3}>
                            <Typography variant="body2" className={classes.doctorInfo}>
                                <EmailIcon sx={{ verticalAlign: 'bottom' }} /> {profile.email}
                            </Typography>
                        </Grid>
                        <Grid item key="doctorPhone" xs={12} mb={3}>
                            <Typography variant="body2" className={classes.doctorInfo}>
                                <LocalPhoneIcon sx={{ verticalAlign: 'bottom' }} /> {profile.phone}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        color="success"
                        className={classes.actionButton}
                        href={`https://wa.me/3935663203?text=Vorrei%20prenotare%20una%20visita%20con%20${profile.title}%20${profile.last_name}%20${profile.first_name}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{backgroundColor: '#25D366'}}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16" style={{marginRight: '8px'}}>
                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                        Richiedi un appuntamento
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

function DoctorProfile({ doctorProfile }) {

    const pageInfo = [
        {
            title: 'Specialisti',
            subtitle: 'Si effettuano visite mediche in numerose branche specialistiche',
        },
    ];

    return (
        <>
            <PageHeader pageInfo={pageInfo} />
            <Box>
                <Container maxWidth="xl">
                    <Profile doctorProfile={doctorProfile} />
                </Container>
            </Box>
        </>
    );
};

export default DoctorProfile;